import {ORDER_FILTER, SEARCH_FILTERS} from '@/src/app/constants/search';
import usePagination from '@/src/hooks/usePagination';
import ActiveJobPositionsLayout from '@/src/jobPortal/clinicPositions/components/ActiveJobPositionsLayout';
import useClinicPositions, {
  STATUS_JOBS_LIST,
} from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import Pagination from '@/src/ui/pagination/container/PaginationContainer';

import css from '../styles/ActiveJobPositionsLayout.module.css';

const INITIAL_SETTINGS = {
  [SEARCH_FILTERS.PER_PAGE]: '8',
  [SEARCH_FILTERS.OFFSET]: '0',
  [SEARCH_FILTERS.FILTERS_STATUS]: STATUS_JOBS_LIST[0].value,
  [SEARCH_FILTERS.ORDER]: ORDER_FILTER.DESC,
};

const ActiveJobPositions = () => {
  const {
    deletePositionWithConfirm,
    active,
    archivePositionWithConfirm,
    openVacancyApplicants,
    getPositionsList,
    isLoading,
  } = useClinicPositions();
  const {onPageChange, query} = usePagination({
    initialSettingsPage: INITIAL_SETTINGS,
    callback: getPositionsList,
  });

  return (
    <div className={css.withPagination}>
      <div className={css.tablesWrapper}>
        <ActiveJobPositionsLayout
          openVacancyApplicants={openVacancyApplicants}
          data={active.data}
          onDeleteClick={deletePositionWithConfirm}
          onArchiveClick={archivePositionWithConfirm}
          isLoading={isLoading}
        />
      </div>
      <Pagination
        startPage={
          Number(query[SEARCH_FILTERS.OFFSET]) /
          Number(query[SEARCH_FILTERS.PER_PAGE])
        }
        onPageChange={onPageChange}
        totalItems={active.totalAmount || 0}
        limitPerPage={Number(query[SEARCH_FILTERS.PER_PAGE])}
      />
    </div>
  );
};

export default ActiveJobPositions;
